import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=4f3ee948&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=js"
export * from "./MemberDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=4f3ee948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3ee948",
  null
  
)

export default component.exports